import styled, { css } from 'styled-components';

// @ts-ignore
type TSIconProps = InferProps<typeof Icon.propTypes>;

// add prop disabled to the icon
const Icon = styled.i<TSIconProps>`
    ${({ withoutMask, name, disabled }) => withoutMask ? css`
        background: url("/icons/${name}.svg") no-repeat center;
        background-size: contain;
    ` : css`
        ${disabled ? css`
            opacity: ${({ theme }) => theme.extras.opacity.disabled};
        ` : ''}
        mask: url("/icons/${name}.svg") no-repeat center;
        -webkit-mask: url("/icons/${name}.svg") no-repeat center;
        background-color: currentColor;
        mask-size: contain;
        -webkit-mask-size: contain;
    `}
  display: inline-block;
  width: ${({
        theme,
        size
    }) => theme.typography.icon[size ?? 'md']};
  height: ${({
        theme,
        size
    }) => theme.typography.icon[size ?? 'md']};
`;

export const availableIcons = [
    'alert-circle-light',
    'slider-3-horizontal-light',
    'arrow-from-line-left-light',
    'arrow-4-way-light',
    'phone',
    'credit-card-light',
    'number-outlined',
    'arrow-left-light',
    'arrow-to-line-right-light',
    'doc-light-download',
    'fullscreen-light',
    'question-circle-light',
    'wi-fi-light',
    'paper-plane-light',
    'arrow-shape-turn-right-light',
    'floppy-disk-light',
    'layout-light',
    'pencil-light',
    'box-light',
    'power-light',
    'fullscreen-alt-light',
    'book-open-light',
    'nosign-light',
    'zoom-out-light-1',
    'zoom-in-light',
    'square-on-square-light',
    'caret-left-light',
    'arrow-from-shape-right-light',
    'shield-light',
    'plus-square-light',
    'media-play-light',
    'task',
    'calendar-light',
    'media-stop-circle-light',
    'arrow-from-line-right-light',
    'thumbs-down-light',
    'other',
    'mic-slash-light',
    'chevron-small-right-light',
    'columns-light',
    'printer-light',
    'arrow-from-line-down-light',
    'user-light',
    'cloud-slash-light',
    'arrow-trend-up-light',
    'location-light',
    'google',
    'media-play-circle-light',
    'archivebox-light',
    'pin',
    'arrow-turn-left-up-light',
    'media-forward-light',
    'arrow-to-shape-right-light',
    'arrow-thin-down-light',
    'cloud-arrow-up-light',
    'percent-light',
    'media-stop-light',
    'temperature',
    'clock-light',
    'checkmark-double-light',
    'arrow-turn-up-right-light',
    'camera-light',
    'house-light',
    'configuration',
    'layers-3-light',
    'arrow-trend-down-light',
    'media-backward-end-light',
    'buildings',
    'arrow-thin-right-light',
    'arrow-to-line-up-light',
    'flag-filled',
    'doc-light',
    'compass-light',
    'arrow-circle-left-light',
    'media-pause-light',
    'mic-light',
    'log',
    'media-backward-light',
    'search-light',
    'arrow-up-light',
    'arrow-down-light',
    'chart-pie-light',
    'arrow-to-line-down-light',
    'envelope-light',
    'bell-light',
    'bell-slash-light',
    'caret-down-light',
    'info-circle-light',
    'thumbs-up-light',
    'chevron-up-light',
    'device-tablet-light',
    'media-pause-circle-light',
    'waveform-ecg-light',
    'arrow-to-shape-down-light',
    'alert-triangle-light',
    'square-4-grid-light',
    'plus-circle-light',
    'eye-light',
    'chevron-small-left-light',
    'paper-clip-light',
    'arrow-turn-right-down-light',
    'crop-light',
    'arrow-turn-up-left-light',
    'arrow-small-up-light',
    'minus-light',
    'arrow-turn-down-right-light',
    'arrow-from-shape-top-light',
    'folder-light',
    'line-3-light',
    'shield-slash-light',
    'xmark-small-light',
    'users-light',
    'command-light',
    'link-alt-light',
    'lock-open-light',
    'fullscreen-exit-light',
    'arrow-turn-down-left-light',
    'chevron-right-light',
    'arrow-2-cw-light',
    'personal',
    'reboot',
    'arrow-2-rectangle-path-light',
    'arrow-small-left-light',
    'dots-6-horizontal-light',
    'external-link-light',
    'suitcase',
    'chevron-left-chevron-right-light',
    'slider-3-vertical-light',
    'dots-6-vertical-light',
    'checkmark-light',
    'zoom-out-light',
    'dots-3-vertical-light',
    'chevron-small-down-light',
    'chip',
    'chartbar-2-light',
    'arrow-cw-light',
    'minus-circle-light',
    'arrow-thin-left-light',
    'arrow-turn-right-up-light',
    'arrow-ccw-light',
    'chevron-left-light',
    'at-sign-light',
    'chartbar-light',
    'zap-light',
    'moon-light',
    'tray-light',
    'caret-right-light',
    'arrow-right-light',
    'cloud-light',
    'arrow-circle-right-light',
    'plus-light',
    'caret-up-light',
    'shippingbox-light',
    'eye-slash-light',
    'xmark-circle-light',
    'xmark-light',
    'map-pin-light',
    'power-mode',
    'flag-empty',
    'giftbox-light',
    'chevron-down-light',
    'dots-9-light',
    'link-light',
    'list-bullet-light',
    'queue',
    'relocate-miner',
    'gear-light',
    'trash-light',
    'filter-settings',
    'bookmark-light',
    'arrow-thin-up-light',
    'filter-light',
    'checkmark-circle-light',
    'arrow-from-line-up-light',
    'dots-3-horizontal-light',
    'media-forward-end-light',
    'arrow-to-line-left-light',
    'file',
    'arrow-2-ccw-light',
    'sun-light',
    'coin',
    'message-bubble-light',
    'arrow-left-arrow-right-light',
    'chevron-small-up-light',
    'cloud-download-light',
    'arrow-small-down-light',
    'bag-light',
    'arrow-small-right-light',
    'arrow-circle-down-light',
    'arrow-circle-up-light',
    'share-light',
    'globe-light',
    'minus-square-light',
    'table-settings',
    'message-bubble-2-light',
    'arrow-up-arrow-down-light',
    'fullscreen-exit-alt-light',
    'image-light',
    'terminal',
    'sharp-light',
    'arrow-shape-turn-left-light',
    'server-light',
    'checkmark-square-light',
    'arrow-turn-left-down-light',
    'lock-light',
    'staff',
    'forbidden-circle',
    'forbidden-circle-thick',
    'forbidden-circle-thin',
    'key',
    'fan',
    'control-board',
    'power-supply',
    'automation',
    'create-task',
    'group',
    'factory-reset',
    'asic',
    'scan-eye',
    'priority/highest',
    'priority/high',
    'priority/medium',
    'priority/low',
    'priority/lowest',
    'messengers/viber',
    'messengers/telegram',
    'messengers/whatsapp',
    'reactions/awesome',
    'reactions/positive',
    'reactions/neutral',
    'reactions/negative',
    'polygon-8',
    'field-text',
    'field-number',
    'field-boolean',
    'tasks-transition-line-example',
    'diagnostic',
    'rocket',
    'tariff',
    'support',
    'gears',
    'eye-add',
    'power-control',
    'accountant',
    'tax-report',
    'send-doc',
    'plug',
    'unplug'
];

export default Icon;
